module.exports = __webpack_public_path__ + "static/9-6503ee5567092fa9c87a23308355a14d.jpg";